import React, { useEffect, useState }  from "react";
import {Menu, Row, Col} from "antd";
import {Link, useHistory} from "react-router-dom";
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
//import IntlMessages from "../../util/IntlMessages";
import {useSelector} from "react-redux";

const SubMenu = Menu.SubMenu;
//const MenuItemGroup = Menu.ItemGroup;

const getMenuPathKey = value => typeof value === 'string'
  ? value.split('?')[0].replace(/^\/+/, '')
  : '';

const getActiveOpenKeys = (navBarItems, selectedKey) => {
  for (const item of navBarItems || []) {
    for (const tab of item.imrTabsInterfaces || []) {
      const activeInterface = (tab.moduleInterfaces || []).find(interfa =>
        getMenuPathKey(interfa.url) === selectedKey
      );

      if (activeInterface) {
        const keys = [
          `Module${item.moduleId}`,
          `Module${item.moduleId}Tab${tab.tabId}Interface0`
        ];

        if (activeInterface.idInterfaceParent != null) {
          keys.push(`Interface${activeInterface.idInterfaceParent}`);
        }

        return keys;
      }
    }
  }

  return [];
};


const SidebarContent = ({sidebarCollapsed, setSidebarCollapsed}) => {

  const history = useHistory();
  let {navStyle, themeType} = useSelector(({settings}) => settings);
  const pathname = useSelector(({common}) => common.pathname);
  const navBarItems = useSelector(({ settings }) => settings.NavBarItems);
  const [openKeys, setOpenKeys] = useState([]);


  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };
  const selectedKey = getMenuPathKey(pathname);

  useEffect(() => {
    const activeOpenKeys = getActiveOpenKeys(navBarItems, selectedKey);
    if (activeOpenKeys.length === 0) return;

    setOpenKeys(currentKeys => Array.from(new Set([...currentKeys, ...activeOpenKeys])));
  }, [navBarItems, selectedKey]);

  return (
    <>
      <SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed}/>
      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <Row>
            <Col sm={16}>
          <UserProfile/>
            
            </Col>
            <Col sm={8}>
          <AppsNavigation/>
            
            </Col>
          </Row>
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            openKeys={openKeys}
            onOpenChange={setOpenKeys}
            selectedKeys={selectedKey ? [selectedKey] : []}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline"
            className="wrap-text-menu gx-navigation-menu">
   {
       navBarItems == null ? null : navBarItems.map(item => {
          return (
            <SubMenu key={`Module${item.moduleId}`} className="gx-menu-group" title={item.moduleDisplay}>
              {
                (item.imrTabsInterfaces || []).map((tab) => {
                  const moduleInterfaces = tab.moduleInterfaces || [];

                  return (
                   <SubMenu key={`Module${item.moduleId}Tab${tab.tabId}Interface0`} popupClassName={`${getNavStyleSubMenuClass(navStyle)} gx-navigation-submenu-popup`}
                            title={<span className="gx-navigation-section-title"><i className="icon icon-widgets"/>
                                            <span>{tab.tabsDisplay}</span>
                                   </span>}>
                      {
                        moduleInterfaces.map(interfa => {
                          const hasParent = moduleInterfaces.some(
                            parent => parent.id === interfa.idInterfaceParent
                          );
                          if (hasParent) return null;

                          const children = moduleInterfaces.filter(child =>
                            child.idInterfaceParent === interfa.id && getMenuPathKey(child.url)
                          );

                          if (children.length > 0) {
                            return (
                              <SubMenu
                                key={`Interface${interfa.id}`}
                                popupClassName="gx-navigation-submenu-popup"
                                title={interfa.displayInterface}>
                                {children.map(child => (
                                  <Menu.Item
                                    key={getMenuPathKey(child.url)}
                                    onClick={() => history.push(`${child.url}?I=${child.id}&T=${tab.tabId}&M=${item.moduleId}`)}>
                                    <span>{child.displayInterface}</span>
                                  </Menu.Item>
                                ))}
                              </SubMenu>
                            );
                          }

                          const menuKey = getMenuPathKey(interfa.url);
                          if (!menuKey) return null;

                          return (
                            <Menu.Item key={menuKey}>
                              <Link to={`${interfa.url}?I=${interfa.id}&T=${tab.tabId}&M=${item.moduleId}`}>
                                <span>{interfa.displayInterface}</span>
                              </Link>
                            </Menu.Item>
                          );
                        })
                      }
                    </SubMenu>
                  )
                })
              }
            </SubMenu>
                )
              })
            } 
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;

